function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { createStyles, Input as MantineInput } from "@mantine/core";
import { tokens } from "@releaseit/design-system";
export var useStyles = createStyles(function(theme, params, getRef) {
    var iconRef = getRef("icon");
    var multiSelectValueRef = getRef("multiSelectValue");
    return {
        root: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            isolation: "isolate"
        },
        input: _objectSpread(_defineProperty({
            fontFamily: tokens.FONTS.sans,
            fontSize: tokens.FONT_SIZES.base,
            borderColor: tokens.COLORS.gray[300],
            borderRadius: tokens.RADII.md,
            textOverflow: "ellipsis",
            transition: "all 0.15s ease-in-out",
            paddingLeft: 10,
            paddingRight: 10
        }, ".".concat(iconRef, " + &"), {
            paddingLeft: tokens.SPACING[10]
        }), params.label && {
            height: "auto",
            paddingTop: tokens.SPACING[5]
        }, params.hasFocus && {
            "&&:not(:disabled)": {
                color: "black",
                backgroundColor: "".concat(tokens.COLORS["primary-green"], "0d"),
                boxShadow: "0 0 0 4px ".concat(tokens.COLORS["primary-green"], "40")
            }
        }, params.error && {
            "&&:not(:disabled)": {
                color: "black",
                backgroundColor: "".concat(tokens.COLORS.error, "0d"),
                borderColor: tokens.COLORS.error,
                boxShadow: "0 0 0 4px ".concat(tokens.COLORS.error, "40")
            }
        }),
        label: _objectSpread({
            zIndex: 1,
            position: "absolute",
            pointerEvents: "none",
            paddingLeft: 11,
            paddingTop: 16,
            transition: "all 75ms ease-in-out",
            color: theme.colors.gray[6],
            fontFamily: tokens.FONTS.sans,
            fontSize: tokens.FONT_SIZES.base,
            fontWeight: tokens.FONT_WEIGHTS.medium
        }, (params.isActive || params.icon || params.placeholder) && {
            paddingTop: 6,
            fontSize: tokens.FONT_SIZES.xs,
            textTransform: "uppercase",
            color: tokens.COLORS.gray[800]
        }, params.disabled && {
            color: tokens.COLORS.gray[500]
        }, params.error && {
            color: tokens.COLORS.error
        }, _defineProperty({}, ".".concat(multiSelectValueRef, " &"), {
            fontFamily: tokens.FONTS.sans,
            color: tokens.COLORS.gray[800],
            lineHeight: 1.2,
            position: "unset",
            padding: "unset"
        })),
        description: _objectSpread({
            order: 1,
            marginTop: 7,
            marginBottom: -3,
            fontSize: "".concat(tokens.FONT_SIZES.sm, " !important")
        }, params.error && {
            display: "none"
        }),
        error: {
            order: 2,
            marginTop: 7,
            marginBottom: -3,
            lineHeight: 1.2
        },
        icon: _objectSpread({
            ref: iconRef,
            color: tokens.COLORS.gray[800],
            left: tokens.SPACING[1]
        }, params.label && {
            paddingTop: tokens.SPACING[6]
        }),
        value: {
            ref: multiSelectValueRef
        },
        hovered: {
            backgroundColor: theme.colors.gray[0]
        }
    };
});
export function Input(_param) {
    var classNames = _param.classNames, props = _objectWithoutProperties(_param, [
        "classNames"
    ]);
    var ref2 = _slicedToArray(React.useState(false), 2), hasFocus = ref2[0], setHasFocus = ref2[1];
    var ref1 = _slicedToArray(React.useState(false), 2), hasValue = ref1[0], setHasValue = ref1[1];
    var isActive = hasFocus || hasValue;
    var classes = useStyles(_objectSpread({
        hasFocus: hasFocus,
        isActive: isActive
    }, props), {
        name: "Input",
        classNames: classNames
    }).classes;
    return /*#__PURE__*/ _jsx(MantineInput, _objectSpread({}, props, {
        onFocus: function(e) {
            var ref;
            setHasFocus(true);
            (ref = props.onFocus) === null || ref === void 0 ? void 0 : ref.call(props, e);
        },
        onBlur: function(e) {
            var ref;
            setHasFocus(false);
            (ref = props.onBlur) === null || ref === void 0 ? void 0 : ref.call(props, e);
        },
        onChange: function(e) {
            var ref;
            setHasValue(!!e.target.value);
            (ref = props.onChange) === null || ref === void 0 ? void 0 : ref.call(props, e);
        },
        classNames: classes
    }));
}
